export enum DATA_FIELD_TYPE {
    TYPE_STRING = 1,
    TYPE_INT = 2,
    TYPE_FLOAT = 3,
    TYPE_URL = 4,
}
